module.exports = __webpack_public_path__ + "static/media/img-hospital-info-mobile.dd2e4d76.png";